








import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  private keys: any = [
    {
      label: "性别",
      value: "性别",
    },
    {
      label: "出生年月",
      value: "出生年月",
    },
    {
      label: "职业",
      value: "职业",
    },
    {
      label: "病史陈述者",
      value: "病史陈述者",
    },
    {
      label: "可靠程度",
      value: "可靠程度",
    },
  ];
  private audioAction: any = {
    method: "pause",
  };
}
